import { useEffect } from "react";
import { Outlet, createFileRoute, useNavigate, useRouterState } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@sx/ui";
import { queryPolicies } from "@sx/api-client";

import { registerWorkspaceHeader } from "../../../lib/nav";
import { WorkspaceGate } from "../../../shell/WorkspaceGate";
import { useProjectAddress } from "../../../shell/project";
import { workAtlasKeys } from "../../../workspaces/work-atlas/api";
import { atlasViews, taskNavigation } from "../../../workspaces/projects/task-navigation";
import { useWorkAtlas } from "../../../workspaces/work-atlas/project";

export const Route = createFileRoute("/_console/p/$org/$project/work-atlas")({
  component: WorkAtlasLayout,
});

/* The atlas is everyone's, but it is read through the Catalog's door with this project's
 * credential, so the door's answer to the overview is the workspace's gate. */
function WorkAtlasLayout() {
  const address = useProjectAddress();
  const navigate = useNavigate();
  const pathname = useRouterState({ select: state => state.location.pathname });
  const viewPath = pathname.replace(`/p/${address.org}/${address.project}`, "/p/$org/$project");
  const browsing = !viewPath.endsWith("/opportunities");
  const { projectId, api } = useWorkAtlas();
  const atlas = useQuery({
    queryKey: workAtlasKeys.atlas(projectId),
    queryFn: api.atlas,
    ...queryPolicies.reference,
  });
  useEffect(
    () => registerWorkspaceHeader({ workspace: "work-atlas", items: taskNavigation(address), presentation: "tabs" }),
    [address],
  );
  if (atlas.data === undefined) return <WorkspaceGate workspace="work-atlas" query={atlas} />;
  return <>
    {browsing ? <div className="flex items-center gap-3 border-b px-6 py-2">
      <label className="text-supporting text-muted-foreground" htmlFor="atlas-view">Browse</label>
      <Select value={viewPath} onValueChange={value => {
        const view = atlasViews.find(item => item.to === value);
        if (view) void navigate({ to: view.to, params: address });
      }}>
        <SelectTrigger id="atlas-view" className="w-48"><SelectValue /></SelectTrigger>
        <SelectContent>{atlasViews.map(view => <SelectItem key={view.to} value={view.to}>{view.label}</SelectItem>)}</SelectContent>
      </Select>
    </div> : null}
    <Outlet />
  </>;
}
